import { UiCommandRenderCell } from "@cer/cer-data/cer-data-types";
import { CerToolbarItemState } from "@cer/cer-toolbar/cer-toolbar-command-adapter";
import { uiCmdComponentMaximize, uiCmdDocumentDownload, uiCmdDocumentDownloadAsPdf, uiCmdDocumentDownloadOriginalNoIcon, uiCmdDocumentOpenLink, uiCmdDocumentZoomIn, uiCmdDocumentZoomOut } from "@cer/cer-ui/cer-ui-commands";

export type CerViewDocumentType = 'generic' | 'pdf' | 'markdown' | 'folder';

export type CerViewDocumentGenericType = 'div' | 'img' | 'iframe';

export function fileNameExtensionGet(url: string): string {
  var ext: string = null;
  if (url?.length > 0) {
    const segments = url.split(".");
    if (segments.length > 1) {
      ext = '.' + segments[segments.length - 1].toLowerCase();
    }
  }
  return ext;
}

export function fileNameExtensionEnsure(url: string, ext: string): string {
  var splits = url?.split(".");
  if (splits.length > 1) {
    return url;
  }
  return url + ext;
}

export function fileNameExtensionRemove(url: string): string {
  var splits = url?.split(".");
  if (splits.length > 1) {
    splits.pop();
    return splits.join(".");
  }
  return url;
}


export function fileNamePrefixFolder(folderName: string, fileName: string): string {
  if (folderName?.length > 0) {
    return (folderName.endsWith('/') ? folderName.slice(0, -1) : folderName) +
      '/' +
      (fileName.startsWith("/") ? fileName.substring(1) : fileName);

  }
  return fileName;
}

export function isDocTypeFolder(docType: string): boolean {
  return fileExtensionsIconFolder.includes(docType);
}

export const docTypeFolder = '<folder>';
export const fileExtensionMarkdown = '.md';

const fileExtensionsIconFolder = [docTypeFolder];
const fileExtensionsIconMail = ['.eml'];
const fileExtensionsIconHtml = ['.html', '.htm'];
const fileExtensionsIconMarkdown = [fileExtensionMarkdown];
const fileExtensionsIconPlainText = ['.txt', '.xml', '.json'];
const fileExtensionsIconPdf = ['.pdf'];
const fileExtensionsIconWord = ['.docx', '.doc', '.odt', '.rtf'];
const fileExtensionsIconPages = ['.pages'];
const fileExtensionsIconExcel = ['.xlsx', '.xlsw', '.xls'];
const fileExtensionsIconImage = [
  ".png", ".jpg", ".jpeg", ".gif",
  ".tif", ".tiff", ".webp", ".svg",
  ".heic", ".heif"
];

export function documentTypeByExtension(extension: string): CerViewDocumentType {
  if (extension?.length > 0) {
    const complete = extension.startsWith('.') || extension.startsWith('<');
    const ext = complete ? extension : '.' + extension;
    return fileExtensionsIconFolder.includes(ext) ? 'folder' :
      fileExtensionMarkdown == ext ? 'markdown' :
        fileExtensionsIconPdf.includes(ext) ? 'pdf' :
          'generic';
  }
  return null;
}

export function documentGenericTypeByExtension(extension: string): CerViewDocumentGenericType {
  //
  if (extension?.length > 0) {
    const complete = extension.startsWith('.') || extension.startsWith('<');
    const ext = complete ? extension : '.' + extension;
    return fileExtensionsIconHtml.includes(ext) ? 'iframe' :
      (fileExtensionsIconImage.includes(ext) || fileExtensionsIconPages.includes(ext)) ? 'img' :
        fileExtensionsIconPlainText.includes(ext) ? 'iframe' : //'div' :
          null;
  }
  return null;
}

function fileExtensionIcon(ext: string): string {
  return fileExtensionsIconFolder.includes(ext) ? 'folder' :
    fileExtensionsIconMail.includes(ext) ? 'mail' :
      fileExtensionsIconHtml.includes(ext) ? 'text' :
        fileExtensionsIconPlainText.includes(ext) ? 'text' :
          fileExtensionsIconMarkdown.includes(ext) ? 'text' :
            fileExtensionsIconPdf.includes(ext) ? 'pdf' :
              fileExtensionsIconImage.includes(ext) ? 'photo' :
                fileExtensionsIconExcel.includes(ext) ? 'excel' :
                  fileExtensionsIconWord.includes(ext) ? 'word' :
                     fileExtensionsIconPages.includes(ext) ? 'pages' :
                     null;
}

export function iconImgSrcSource(icon: string) {
  return icon?.length > 0 ? `/assets/icons/${icon}.svg` : null;
}

export function renderFileExtension(e: UiCommandRenderCell) {
  const extension = e.value;
  const imgEle = docTypeCreateImg(extension);
  if (imgEle != null) {
    e.cell.innerHTML = '';
    e.cell.append(imgEle);
  }
}

export function docTypeCreateImg(extension: string): HTMLImageElement {
  const icon = fileExtensionIcon(extension);
  if (icon == null) {
    return null;
  }
  return iconImageElement(icon, extension);
}

export function iconImageTextHtml(): string {
  return iconImageElement('text').outerHTML;
}

export function iconImageFolderHtml(): string {
  return iconImageElement('folder').outerHTML;
}

function iconImageElement(icon: string, extension: string = null) {
  const img: HTMLImageElement = document.createElement('img') as HTMLImageElement;
  img.src = iconImgSrcSource(icon);
  img.title = extension;
  img.classList.add('e-icon-img');
  return img;
}


export function documentToolbarItemsStateGet(zoomInActive: boolean, zoomOutActive: boolean, url: string, originalUrl: String, originalFileName: string): Map<string, CerToolbarItemState> {
  const urlActive = url?.length > 0;
  const origActive = originalUrl?.length > 0 && url != originalUrl && originalFileName?.length > 0;
  const origIconSrc = origActive ? iconImgSrcSource(fileExtensionIcon(fileNameExtensionGet(originalFileName))) : null;

  const states = new Map<string, CerToolbarItemState>();
  states.set(uiCmdDocumentDownloadOriginalNoIcon.id, { visible: origActive, iconSrc: origIconSrc });
  states.set(uiCmdDocumentDownload.id, { visible: urlActive });
  states.set(uiCmdDocumentOpenLink.id, { visible: urlActive });
  states.set(uiCmdDocumentZoomIn.id, { visible: urlActive && zoomInActive });
  states.set(uiCmdDocumentZoomOut.id, { visible: urlActive && zoomOutActive });
  states.set(uiCmdComponentMaximize.id, { align: 'right', alignPosition: 'last' });

  return states;
}

export function plainUrl(url: string): string {
  return url + "&plain=1";
}

